<template>
  <div>
    <component :is="component" :user="user" :type="type" />
  </div>
</template>

<script>
import sip from '@/components/lists/clients/clientsCallBtn/sip/index'
import opentok from '@/components/lists/clients/clientsCallBtn/opentok/index'

export default {
    name: 'call-btn-view',
    props: {
        user: {
            required: true,
        },
        type: {
            required: true,
        },
    },
    components: {
        opentok,
        sip,
    },
    computed: {
        component() {
            return this.$config.behavior === 'profy' ? 'sip' : ''
        },
    },
}
</script>

<style lang="scss">
.userlist__item:hover .userlist__item-button {
  opacity: 1;
}

.userlist__item-button {
  margin-right: 16px;
  cursor: pointer;

  & .icon {
    width: 30px;
    height: 30px;
    transition: 0.5s;
    &:hover {
      transform: scale(1.2);
    }
  }
}
</style>
